import { render, staticRenderFns } from "./FAQView.vue?vue&type=template&id=274819f4&"
import script from "./FAQView.vue?vue&type=script&lang=js&"
export * from "./FAQView.vue?vue&type=script&lang=js&"
import style0 from "./FAQView.vue?vue&type=style&index=0&id=274819f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports